import React from 'react';
import {
    Button,
    Card,
    CardBody,
    CardGroup,
    Col,
    Container,
    Form,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row
} from "reactstrap";
import 'layout/login.scss';
import {FTUComponent, FTUTrans} from 'components/FTUComponent';
import {withTranslation} from 'react-i18next';
import {AuthenticationService} from 'services/access/AuthenticationService';
import {showMessageBox, showErrorBox, showWarningBox} from "components/MessageBox";
import {RESPONSE_STATUS} from "../constants/AppProps";


class Login extends FTUComponent {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: ''
        };
    }

    componentDidMount() {
        document.title = this.trans("brwTitle");
        document.getElementById("username").focus();
    }

    afterLogin = (data) => {
        if (data && (data.status !== RESPONSE_STATUS.SUCCESS)) {
            if (data.data.message != null) {
                showErrorBox(data.data.message);
                return false;
            }
            return true;
        }
    }

    onSubmit = async (e) => {
        e.preventDefault();
        if (!this.validateForm()) {
            return
        } else {
            //xu ly login
            await AuthenticationService.login(this.state.username, this.state.password, this.afterLogin);
            if (AuthenticationService.isLogin()) {
                this.props.history.push('/');
            }
        }

    }

    validateForm() {
        if (this.state.username === undefined || this.state.username === '') {
            //showWarningBox(this.trans("emptyUsername"));
            showWarningBox(this.trans("emptyUsername"));
            return false;
        }
        if (this.state.password === undefined || this.state.password === '') {
            //showWarningBox(this.trans("emptyPassword"));
            showWarningBox(this.trans("emptyPassword"));
            return false;
        }

        return true;
    }

    render() {
        if (AuthenticationService.isLogin()) {
            this.props.history.push('/');
        }
        const logo = process.env.PUBLIC_URL + '/assets/layout/images/mbf-logo.png';
        const backgroud = 'url(assets/layout/images/backgroud.png) no-repeat fixed center';

        return (
            <div style={{
                background:
                    "url('" + process.env.PUBLIC_URL + "/assets/layout/images/background.jpg') no-repeat fixed center"
            }} className="app flex-row align-items-center">
                <Container className="content-section introduction growl-demo">
                    <Row className="justify-content-center">
                        <Col md="8">
                            <CardGroup>
                                <Card className="p-4">
                                    <CardBody>
                                        <Form onSubmit={this.onSubmit}>
                                            <img alt="Logo" src={logo}/>
                                            <p className="text-muted"><FTUTrans ns="login" name="title"/></p>
                                            <InputGroup className="mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="icon-user"/>
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    id="username"
                                                    name="username"
                                                    type="text"
                                                    placeholder={this.trans("username")}
                                                    onChange={this.txtHandleChange}
                                                />
                                            </InputGroup>
                                            <InputGroup className="mb-4">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="icon-lock"/>
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    placeholder={this.trans("password")}
                                                    onChange={this.txtHandleChange}
                                                />
                                            </InputGroup>
                                            <Row>
                                                <Col xs="6">
                                                    <Button type="submit" style={{
                                                        backgroundColor: 'rgb(0, 80, 190)',
                                                        color: 'rgb(255, 255, 255)'
                                                    }}>
                                                        <FTUTrans ns="login" name="login"/>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>
                                <Card
                                    className="text-white py-5 d-md-down-none"
                                    style={{
                                        width: "50%",
                                        backgroundColor: "rgb(0,0,0,0.4)"
                                    }}
                                >
                                    <CardBody className="text-center">
                                        <div>
                                            <h1 style={{color: "#ffffff"}}><FTUTrans ns="common" name="app.title"/></h1>
                                        </div>
                                    </CardBody>
                                </Card>
                            </CardGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withTranslation("login")(Login);